export const formatPhone = (phone?: string, fallback = '-'): string => {
  if (!phone) return fallback

  // Remove all non-digit characters except leading +
  const hasPlus = phone.startsWith('+')
  const digits = phone.replace(/\D/g, '')

  if (digits.length === 0) return phone

  // Handle US numbers (10 or 11 digits)
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`
  }

  // For other formats, just return with the + if it had one
  if (hasPlus) {
    return `+${digits}`
  }

  return phone
}
